export function chatLoadErrorMessage(statusCode: number | undefined): string {
    if (statusCode === 404) return "This chat was not found in the current organization. Check that you have selected the correct organization.";
    if (statusCode === 403) return "You do not have permission to access this chat.";
    return "This chat could not be loaded. Please reload to try again.";
}
